import { createReducer } from "@reduxjs/toolkit";
import {
  createConsentForm,
  createConsentFormSuccess,
  createConsentFormFailure,
  getConsentForms,
  getConsentFormsSuccess,
  getConsentFormsFailure,
  getPortionConsentFormsSuccess,
  getPortionConsentFormsFailure,
  getReceivedFormsSuccess,
  getReceivedFormsFailure,
  getPortionReceivedFormsSuccess,
  getPortionReceivedFormsFailure,
  getPortionConsentForms,
  getReceivedForms,
  getPortionReceivedForms,
  getNewSignConsentFormsCountSuccess,
  setSigningConsentFormId,
  assignFormSuccess,
  assignForm,
} from "./actions";

const initialState = {
  consentForms: {
    list: [],
    formsById: {},
    nextOffset: undefined,
    totalCount: undefined,
    isLoading: false,
  },
  receivedForms: {
    list: [],
    formsById: {},
    nextOffset: undefined,
    totalCount: undefined,
    isLoading: false,
  },
  newSignConsentFormsCount: 0,
  signingConsentFormId: null,
  assigningConsentFormId: null,
  isLoading: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(createConsentForm.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(createConsentFormSuccess.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(createConsentFormFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }))

    .addCase(getConsentForms.type, (state, payload) => ({
      ...state,
      consentForms: {
        ...state.consentForms,
        ...payload,
        isLoading: true,
      },
    }))
    .addCase(getConsentFormsSuccess.type, (state, { payload }) => ({
      ...state,
      consentForms: {
        ...state.consentForms,
        list: payload.list,
        formsById: {
          ...state.consentForms.formsById,
          ...payload.formsById,
        },
        nextOffset: payload.nextOffset,
        totalCount: payload.totalCount,
        consentForms: {
          ...state.consentForms,
        },
        isLoading: false,
      },
    }))
    .addCase(getConsentFormsFailure.type, (state) => ({
      ...state,
      consentForms: {
        ...state.consentForms,
        isLoading: false,
      },
    }))

    .addCase(getPortionConsentForms.type, (state) => ({
      ...state,
      consentForms: {
        ...state.consentForms,
        isLoading: true,
      },
    }))
    .addCase(getPortionConsentFormsSuccess.type, (state, { payload }) => {
      return {
        ...state,
        consentForms: {
          ...state.consentForms,
          list: [...state.consentForms.list, ...payload.list],
          formsById: {
            ...state.consentForms.formsById,
            ...payload.formsById,
          },
          nextOffset: payload.nextOffset,
          totalCount: payload.totalCount,
          isLoading: false,
        },
      };
    })
    .addCase(getPortionConsentFormsFailure.type, (state) => ({
      ...state,
      consentForms: {
        ...state.consentForms,
        isLoading: false,
      },
    }))

    .addCase(getReceivedForms.type, (state, payload) => ({
      ...state,
      receivedForms: {
        ...state.receivedForms,
        ...payload,
        isLoading: true,
      },
    }))
    .addCase(getReceivedFormsSuccess.type, (state, { payload }) => ({
      ...state,
      receivedForms: {
        ...state.receivedForms,
        list: payload.list,
        formsById: {
          ...state.receivedForms.formsById,
          ...payload.formsById,
        },
        nextOffset: payload.nextOffset,
        totalCount: payload.totalCount,
        isLoading: false,
      },
    }))
    .addCase(getReceivedFormsFailure.type, (state) => ({
      ...state,
      receivedForms: {
        ...state.receivedForms,
        isLoading: false,
      },
    }))
    .addCase(getPortionReceivedForms.type, (state, payload) => ({
      ...state,
      receivedForms: {
        ...state.receivedForms,
        ...payload,
        isLoading: true,
      },
    }))
    .addCase(getPortionReceivedFormsSuccess.type, (state, { payload }) => {
      return {
        ...state,
        receivedForms: {
          ...state.receivedForms,
          list: [...state.receivedForms.list, ...payload.list],
          formsById: {
            ...state.receivedForms.formsById,
            ...payload.formsById,
          },
          nextOffset: payload.nextOffset,
          totalCount: payload.totalCount,
          isLoading: false,
        },
      };
    })
    .addCase(getPortionReceivedFormsFailure.type, (state) => ({
      ...state,
      receivedForms: {
        ...state.receivedForms,
        isLoading: false,
      },
    }))
    .addCase(getNewSignConsentFormsCountSuccess.type, (state, { payload }) => ({
      ...state,
      newSignConsentFormsCount: payload.newSignConsentFormsCount,
    }))

    .addCase(setSigningConsentFormId.type, (state, { payload }) => ({
      ...state,
      signingConsentFormId: payload.id,
    }))
    .addCase(assignForm.type, (state, { payload }) => ({
      ...state,
      assigningConsentFormId: payload.uuid,
    }))
    .addCase(assignFormSuccess.type, (state) => ({
      ...state,
      assigningConsentFormId: null,
    }));
});
